// @flow

import { Base, Heading } from '@gandi/ui';

import {
  CommercialPoint,
  type Props as CommercialPointProps,
} from './CommercialPoint';

import styles from './CommercialBlock.scss';

type Props = {
  title: string,
  commercialPoints: Array<string | React.MixedElement>,
  link?: React.Node,
  commercialPointsIconName: CommercialPointProps['iconName'],
};

export function CommercialBlock({
  title,
  commercialPoints,
  link,
  commercialPointsIconName,
}: Props): React.MixedElement {
  return (
    <Base
      flex
      flexAlignItemsCenter
      flexWrap
      gap="base"
      padding="base"
      backgroundColor="surface"
      className={styles.container}
    >
      <Base flex flexCol className={styles.title} gap="spacing-5x">
        <Heading fontSize="xl">{title}</Heading>
        {link}
      </Base>
      <ul className={styles.points}>
        {commercialPoints.map((point, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <CommercialPoint key={i} iconName={commercialPointsIconName}>
            {point}
          </CommercialPoint>
        ))}
      </ul>
    </Base>
  );
}
